import { render } from "./SelectCom.vue?vue&type=template&id=19439220"
import script from "./SelectCom.vue?vue&type=script&lang=js"
export * from "./SelectCom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__